<template>
  <div class="warp">
    <div class="record-view bg-write">
    <h1 class="record-title">门诊病历</h1>
    <div class="patient-info">
      <p class="mb16">
        <span class="record__label">病历号：</span>
        <span class="record__content">{{medicalRecordDetail.recordsNo}}</span>
      </p>
      <div class="mb16 flex align-center">
        <p class="flex-1">
          <span class="record__label">姓名：</span>
          <span class="record__content">{{medicalRecordDetail.name}}</span>
        </p>
        <p class="flex-1">
          <span class="record__label">性别：</span>
          <span class="record__content">{{medicalRecordDetail.sex | sex }}</span>
        </p>
      </div>
      <div class="mb16 flex align-center">
        <p class="flex-1">
          <span class="record__label">年龄：</span>
          <span class="record__content">{{medicalRecordDetail.age?medicalRecordDetail.age+'岁':''}}</span>
        </p>
        <p class="flex-1">
          <span class="record__label">科室：</span>
          <span class="record__content">{{medicalRecordDetail.departmentName}}</span>
        </p>
      </div>
      <p>
        <span class="record__label">就诊时间：</span>
        <span class="record__content">{{medicalRecordDetail.advisoryTime | parseDate}}</span>
      </p>
    </div>
    <div class="illness-detail">
      <div class="flex mb8">
        <div class="illness-detail-label record__label"><span>主诉</span>：</div>
        <div class="illness-detail-content record__content flex-1 word-break">{{medicalRecordDetail.patientComplaint||'无'}}</div>
      </div>
      <div class="flex mb8">
        <div class="illness-detail-label record__label"><span>现病史</span>：</div>
        <div class="illness-detail-content record__content flex-1 word-break">{{medicalRecordDetail.medicalDesc||'无'}}</div>
      </div>
      <div class="flex mb8">
        <div class="illness-detail-label record__label">既往史：</div>
        <div class="illness-detail-content record__content flex-1 word-break">{{medicalRecordDetail.diseaseHistory||'无'}}</div>
      </div>
      <div class="flex mb8">
        <div class="illness-detail-label record__label"><span >过敏史</span>：</div>
        <div class="illness-detail-content record__content flex-1 word-break">{{medicalRecordDetail.allergyHistory||'无'}}</div>
      </div>
      <div class="flex mb8">
        <div class="illness-detail-label record__label"><span>诊断</span>：</div>
        <div class="illness-detail-content record__content flex-1 word-break">{{medicalRecordDetail.diseaseDiagnosis?medicalRecordDetail.diseaseDiagnosis.join('、'):'无'}}</div>
      </div>
      <div class="flex mb36">
        <div class="illness-detail-label record__label"><span >处理</span>：</div>
        <div class="illness-detail-content record__content flex-1 word-break" v-html="medicalRecordDetail.handlingSuggestions||'无'"></div>
      </div>
      <div class="flex justify-end">
        <div class="record__label">医生签名：</div>
        <div>
          <van-image width="80" height="45" :src="medicalRecordDetail.doctorSignImg||''" />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      medicalRecordDetail: {},
    };
  },

  created() {
    this.$fetch.fetchGetMedicalRecordDetail({recordId:this.$route.query.recordsId}).then((data) => {
      this.medicalRecordDetail = data;
    });
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
@black-5: #595959; //次要文字
@black-2: #262626; //加醋文字
.record-view{
  padding: 36px 16px  16px 16px;
  margin: 10px 16px;
  background: #FFF;
  color: @black-2;
  border-radius: 8px;
  .patient-info{
    padding: 16px 0;
    border-bottom: 1px solid #eee;
  }
  .record-title{
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 18px;
    text-align: center;
  }
  .record__label{
    color: @black-2;
    font-size: 16px;
    font-weight: bold;
  }
  .record__content{
    color: @black-2;
    font-size: 16px;
  }
  .mb16{
    margin-bottom: 16px;
  }
  .mb8{
    margin-bottom: 8px;
  }
  .mb36{
    margin-bottom: 36px;
  }
  .flex-1{
    flex: 1;
  }
  .justify-end{
    justify-content: flex-end;
  }
  .illness-detail{
    padding: 12px 0 16px 0;
    .illness-detail-label{
      line-height: 24px;
    }
    .illness-detail-content{
      line-height: 24px;
    }
  }
  .word-break{
    word-break: break-all;
  }
}
.warp{
  height: auto;
  padding-bottom:1px;
}
</style>
